import DeselectedSurveysViewModel from "../Calculation/DeselectedSurveysViewModel";

export default class RankOrderExportViewModel {

    reportTitle: string = '';
    exportType: string = 'pdf';
    selectionParameters: boolean = true;
    regionsAndAreas: boolean = true;
    mainParameters: boolean = true;
    secondaryFiltering: boolean = true;
    includeEnhancedSiteList: boolean = true;
    rankOrderGraph: boolean = false;
    addUserComments: boolean = false;
    explanatoryCommentsIncluded: boolean = false;
    userComments: string = '';
    fileName: string = '';
    vehicleType: number = 0;
    peakHour: boolean = false;
    deselectedSurveys: DeselectedSurveysViewModel[] = [];
}